// translation-dialog.component.ts
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';

import {Language} from 'src/app/master-data/master-data.model';
import {LanguageService} from 'src/app/shared/language.service';
import {MatError, MatFormField, MatInputModule, MatLabel} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';

export interface TranslationMap {
  [locale: string]: string;
}

export interface TranslationDialogData {
  entityLabel: string;
  languages: Language[];
  translation?: TranslationMap;
}

@Component({
  selector: 'app-translation-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
],
  templateUrl: './translation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./translation-dialog.component.scss']
})
export class TranslationDialogComponent {
  private readonly fb = inject(FormBuilder);
  private readonly dialogRef = inject(MatDialogRef<TranslationDialogComponent>);
  readonly data = inject<TranslationDialogData>(MAT_DIALOG_DATA);
  readonly languageService = inject(LanguageService);
  private dialog = inject(MatDialog);

  readonly form: FormGroup = this.buildForm();

  private buildForm(): FormGroup {
    const controls: Record<string, FormControl<string | null>> = {};

    for (const lang of this.data.languages) {
      controls[lang.locale] = this.fb.control(
        this.data.translation?.[lang.locale] ?? ''
      );
    }

    return this.fb.group(controls);
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close(this.form.getRawValue() as TranslationMap);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  languageKeys(): string[] {
    return Object.keys(this.form.controls);
  }


}
